import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetAllAddresses,
  IGetAllAddressesParams,
} from "./interfaces/IAddress";

const URLs = {
  addresses: "/addresses",
  deleteAddress: "/addresses/",
};
class ApiAddress extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getAllAddressess = (
    page: number,
    limit: number
  ): Promise<IGetAllAddresses> => {
    const params: IGetAllAddressesParams = { page: page, limit: limit };
    return this.get(URLs.addresses, { params });
  };

  manageAddress = (body: any) => {
    const { id } = body;
    delete body.id;
    if (id) return this.put(URLs.addresses + "/" + id, { ...body });
    else return this.post(URLs.addresses, { ...body });
  };
  deleteAddress = (id: number) => this.delete(URLs.deleteAddress + id, {});
}
export default ApiAddress;
